import type { Novidade } from './tipos';

/** Ficha 2026-11-03: filiais junto com a matriz no cadastro de empresa e na negociação. */
export const novidadeFiliais: Novidade = {
  id: '2026-11-03-filiais',
  publicada_em: '2026-11-03',
  tipo: 'melhoria',
  modulo: 'cadastros',
  permissao: 'cadastros.editar',
  textos: {
    pt: {
      titulo: 'Cadastre as filiais junto com a matriz',
      resumo: 'A empresa agora tem filiais de verdade: cadastre ou vincule cada uma e marque as do grupo ao criar a negociação.',
      passos: [
        'Em CRM > Empresas, clique em Criar empresa e marque Esta empresa tem filiais?. Cadastre cada filial com nome e CNPJ, ou escolha uma empresa já cadastrada.',
        'Na ficha da empresa, o cartão Filiais cadastra, vincula, abre e desvincula. Na filial, o cartão Matriz mostra a quem ela pertence.',
        'Ao criar a negociação, escolha uma empresa com matriz ou filiais: as outras do grupo aparecem para marcar. Nenhuma vem marcada, e as marcadas entram como empresas adicionais.',
      ],
    },
    en: {
      titulo: 'Register branches along with the head office',
      resumo: 'Companies now have real branches: register or link each one and check the ones in the group when creating a deal.',
      passos: [
        'In CRM > Companies, click Create company and check Does this company have branches?. Register each branch with name and CNPJ, or choose a registered company.',
        'On the company record, the Branches card registers, links, opens and unlinks. On a branch, the Head office card shows where it belongs.',
        'When creating a deal, choose a company with a head office or branches: the others in the group show up to check. None comes checked, and checked ones join as additional companies.',
      ],
    },
    es: {
      titulo: 'Registra las sucursales junto con la casa matriz',
      resumo: 'La empresa ahora tiene sucursales de verdad: registra o vincula cada una y marca las del grupo al crear la negociación.',
      passos: [
        'En CRM > Empresas, haz clic en Crear empresa y marca ¿Esta empresa tiene sucursales?. Registra cada sucursal con nombre y CNPJ, o elige una empresa ya registrada.',
        'En la ficha de la empresa, la tarjeta Sucursales registra, vincula, abre y desvincula. En la sucursal, la tarjeta Casa matriz muestra a quién pertenece.',
        'Al crear la negociación, elige una empresa con casa matriz o sucursales: las otras del grupo aparecen para marcar. Ninguna viene marcada, y las marcadas entran como empresas adicionales.',
      ],
    },
  },
  treinamento: { curso: 'novidades' },
  rota: '/crm/empresas',
  imagens: [null, null, null],
};
